// mantine
import { Collapse } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// components
import { PopoverButton } from '@newo/ui-kit';
import { Plus } from 'lucide-react';
import { TSkillParameter, TSkillParameterData } from '@newo/api/gateway';
import SectionHeading from '@/components/SectionHeading';
import ParameterForm from '@/modules/Designer/components/Parameters/components/ParameterForm';
import ParameterItem from '@/modules/Designer/components/Parameters/components/ParameterItem';
import NoRecords from '@/components/NoRecords';
// icons
// utils
import { hints } from '@/modules/Designer/Designer.data';

interface ParametersProps {
    items: TSkillParameter[];
    onCreate: (data: TSkillParameterData) => Promise<unknown>;
    onDelete: (parameter: TSkillParameter) => void;
    onUpdate: (parameterId: string, data: TSkillParameterData) => void;
}

const Parameters = ({
    items,
    onCreate,
    onDelete,
    onUpdate
}: ParametersProps) => {
    const [isOpened, { toggle }] = useDisclosure(true);

    const handleSubmit = async (
        data: TSkillParameterData,
        parameterId?: string
    ) => {
        if (parameterId) {
            onUpdate(parameterId, data);
            return;
        }
        return onCreate(data);
    };

    return (
        <div>
            <div className="flex flex-nowrap items-center pr-3">
                <SectionHeading
                    hint={hints.parameters}
                    isOpened={isOpened}
                    title="Parameters"
                    onClick={toggle}
                />
                <PopoverButton title="Add Parameter" trigger={<Plus />}>
                    {(close) => (
                        <ParameterForm
                            onCancel={close}
                            onSubmit={handleSubmit}
                        />
                    )}
                </PopoverButton>
            </div>
            <Collapse in={isOpened}>
                {items.length === 0 ? <NoRecords /> : undefined}
                {items.map((item) => (
                    <ParameterItem
                        key={item.id}
                        parameter={item}
                        onDelete={onDelete}
                        onUpdate={handleSubmit}
                    />
                ))}
            </Collapse>
        </div>
    );
};

export default Parameters;
